import styled, { createGlobalStyle, css } from 'styled-components';

const prefixCls = 'ui-dropdown';

export const dropdownStyles = {
  component: prefixCls,
  componentOpen: `${prefixCls}-open`,
} as const;

const styles = css`
  .${dropdownStyles.component} {
    background: ${({ theme }) => theme.color.surface.modal} !important;
    border-radius: ${({ theme }) => theme.radius.small}px !important;
    box-shadow: ${({ theme }) => theme.shadows.medium} !important;
    width: fit-content;
  }
`;

export const DropdownStyles = createGlobalStyle`
  ${styles};
`;
